import { render } from "./employeeCreate.vue?vue&type=template&id=5ca62163&scoped=true"
import script from "./employeeCreate.vue?vue&type=script&lang=js"
export * from "./employeeCreate.vue?vue&type=script&lang=js"

import "./employeeCreate.vue?vue&type=style&index=0&id=5ca62163&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "E:\\aliPro\\platformpro\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ca62163"]])

export default __exports__